
import { computed, defineComponent, PropType, Ref } from 'vue';
import utilities from '@/shared/utilities.service';
import { VariantImageVersion } from '@/b2c/shared/api/server-apis';

export default defineComponent({
    name: 'ProductCollage',
    props: {
        variants: {
            type: Array as PropType<VariantImageVersion[]>,
            required: true,
        },
        threshold: {
            type: Number,
            required: false,
            default: 3,
        },
        widthOnScreen: {
            type: Number,
            required: false,
            default: 10,
        },
    },
    setup(props) {
        const collage: Ref<VariantImageVersion[]> = computed(() => {
            const items = utilities.toggleCollectionCap(props.variants, props.threshold, false);
            if (items.length < 1) {
                items.push({ sku: 'logo' });
            }
            return items;
        });

        return {
            collage,
        };
    },
});

